type Point = {
  x?: number;
  y?: number;
};

export function getSearchMapDistanceToMouse(
  markerPoint?: Point | null,
  mousePoint?: Point | null
): number {
  const markerX = markerPoint?.x;
  const markerY = markerPoint?.y;
  const mouseX = mousePoint?.x;
  const mouseY = mousePoint?.y;

  if (
    typeof markerX !== "number" ||
    typeof markerY !== "number" ||
    typeof mouseX !== "number" ||
    typeof mouseY !== "number" ||
    !Number.isFinite(markerX) ||
    !Number.isFinite(markerY) ||
    !Number.isFinite(mouseX) ||
    !Number.isFinite(mouseY)
  ) {
    return Number.POSITIVE_INFINITY;
  }

  const deltaX = markerX - mouseX;
  const deltaY = markerY - mouseY;

  return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
}
